import React, { ReactNode } from 'react'
import cn from 'classnames'

import styles from './styles.module.css'

interface ITextProps {
  as?: 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'li' | 'dt' | 'dd'
  children: ReactNode
  className?: string
  variant?:
    | 'textBodyXl'
    | 'textBodyL'
    | 'textBodyM'
    | 'textBodyS'
    | 'captionL'
    | 'titleS'
    | 'titleXs'
  weight?: 'weight1' | 'weight2' | 'weight3' | 'weight4'
  align?: 'start' | 'center' | 'end'
  loading?: boolean
  ellipsis?: boolean
  transform?: 'capitalize' | 'capitalize-first' | 'lowercase' | 'uppercase'
}

export function Text(props: Readonly<ITextProps>) {
  const {
    as: Tag = 'p',
    children,
    variant,
    weight,
    align = 'start',
    className,
    loading,
    ellipsis,
    transform,
  } = props

  const classes = cn(styles.text, className, {
    [styles.textBodyXl]: variant === 'textBodyXl',
    [styles.textBodyL]: variant === 'textBodyL',
    [styles.textBodyM]: variant === 'textBodyM',
    [styles.textBodyS]: variant === 'textBodyS',

    [styles.titleS]: variant === 'titleS',
    [styles.titleXs]: variant === 'titleXs',

    [styles.captionL]: variant === 'captionL',

    [styles.weight1]: weight === 'weight1',
    [styles.weight2]: weight === 'weight2',
    [styles.weight3]: weight === 'weight3',
    [styles.weight4]: weight === 'weight4',

    [styles.start]: align === 'start',
    [styles.center]: align === 'center',
    [styles.end]: align === 'end',

    [styles.loading]: loading,

    [styles.ellipsis]: ellipsis,

    [styles.capitalize]: transform === 'capitalize',
    [styles.capitalizeFirst]: transform === 'capitalize-first',
    [styles.lowercase]: transform === 'lowercase',
    [styles.uppercase]: transform === 'uppercase',
  })

  return <Tag className={classes}>{children}</Tag>
}
